export default __webpack_public_path__ + "static/media/digInKeyWeb.3a7ebddf.jpg";